import React from "react";
import { withAppState, getAppState } from "../../state";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { withFocusable, Loading } from "../../services/visualLibraryService";
import { trackEvent, getRedemptionSuccessTrackingData } from "../../services/analyticsService";
import {
  LandingPageStyled,
  LandingContainerStyled,
  LinkStyled,
  ButtonModalStyled,
  LogoStyled,
  PinItemStyled,
  TextStyled,
  PinContainerStyled,
  LineTextStyled,
  LeftBlock,
  RightBlock,
  AlignText,
  StepNumber,
  StepContainer,
  StepText,
  StepTextContainer,
  QRCodeWrapper,
  PinLoginInfoContainer,
  LoginOptionContainer,
  ButtonsWrapper
} from "./styles/Styled";
import { i18n } from "../../services/i18nService";
import { getGlobalButtonFocusPath } from "../../errors/globalButtons";
import { eVoucherProvisioning } from "../../services/eVoucherEligibilityService";
import { historyMethods } from "../../utils/historyMethods";
import { redirectTo } from "../../services/navigationService";
import { generatePin, loginPin } from "../../services/pinLoginService";
import { routes } from "../../routes";
import { autologin } from "../../services/authenticationService";
import { getLoginRedirectionData } from "../../services/navigationService";
import { getWebPortalURL } from "../../services/tvodService";
import QRCodeReact from "react-qr-code";

import { checkForUmanagedOrNonChangeableMop } from "../../services/billingService";
import FreeLogo from "../../components/FreeLogo";
import { getSdk } from "../../services/sdkService";
import { isAnyAddonStatusActive } from "../../utils/subscriptionUtils";
import * as Sentry from "@sentry/browser";
import { captureEvent, formattedTokenForLogger } from "../../utils/SentryStorageLogger";
import { updateCurrentProfileInIndexDB } from "../../services/multipleProfilesService";
import { QRModal } from "../../services/modalsService";
import { getTwistMigrationUrl, isTwistMigrationEnabled } from "../../utils/twistUtils";
import { config } from "../../config/config";
import { isUserAccountActive } from "../../services/accountStatusService";

const ButtonModalFocus = withFocusable(ButtonModalStyled);
const joinFocusPath = "joinVoucherModal_passThru";
const loginFocusPath = "loginVoucherModal_passThru";
const twistTvFocusPath = "twistTvModal_passThru";
// const flavor = getFlavor();
const proceedToHomePath = "proceedToHomeButtonModalFocusPath";
const SIGNUP = "signup";

function getGenericProvisioningError() {
  let text = `pages.voucherRedemption.errors.generic`;
  let { navigationMode, redirectPath } = getLoginRedirectionData.call(this);
  return {
    dismissable: false,
    modalText: i18n.get(text),
    buttons: [
      {
        label: i18n.get("pages.voucherRedemption.proceedToHomePage"),
        displayBlock: true,
        focusPath: proceedToHomePath,
        buttonHandler: () => {
          this.closeModal(false);
          redirectTo.call(this, routes.profileSelector, { nextPageReference: redirectPath }, navigationMode);
        }
      },
      {
        label: i18n.get("pages.voucherRedemption.exitButton"),
        displayBlock: true,
        focusPath: "exitButtonModalFocusPath",
        buttonHandler: async () => {
          await getSdk();
          getSdk().systemManager.application.exit();
        }
      }
    ]
  };
}

function handleRequestError(error) {
  const { stateActions } = this.props;
  trackEvent(SIGNUP, "evoucher_redemption_error", error.message);
  stateActions.showGlobalModal(getGenericProvisioningError.call(this));
  this.props.setFocus(proceedToHomePath);
}

const PAGE = "login";
class PinLoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pin: "",
      isLoading: true,
      timer: null,
      backDestination: null,
      isVoucherRedeemed: true,
      locale: localStorage.getItem("locale"),
      showQRModal: false
    };
    this.timer = null;
    this.onBack = this.onBack.bind(this);
    this.enterHandler = this.enterHandler.bind(this);
    this.toggleQRCodeModal = this.toggleQRCodeModal.bind(this);
  }

  toggleQRCodeModal(modalShow) {
    this.setState({
      showQRModal: modalShow
    });
  }

  async getPin() {
    const pinResponse = await generatePin();
    this.setState({ pin: pinResponse.pin });
  }

  async componentDidMount() {
    const { location } = this.props;
    this.props.onRef && this.props.onRef(this);
    (async () => {
      await this.getPin().then(async () => {
        this.setState({
          isLoading: false,
          backDestination: location.state && location.state.backDestination
        });
      });

      let { navigationMode, redirectPath } = getLoginRedirectionData.call(this);

      window.pinCheckTimer = setInterval(async () => {
        if (window?.location?.pathname != "/pin") {
          clearInterval(window.pinCheckTimer);
        }
        try {
          const {
            stateActions,
            history,
            applicationState: { voucherData }
          } = this.props;
          const loginPinResponse = await loginPin({ pin: this.state.pin });
          if (loginPinResponse.errorCode === 4009) {
            await this.getPin();
          } else if (loginPinResponse.webToken && loginPinResponse.webToken !== "false") {
            clearInterval(window.pinCheckTimer);
            const sdk = await getSdk();
            await sdk.mediaManager.clearLayoutCache();
            localStorage.setItem("credentials", loginPinResponse.webToken);
            localStorage.setItem("state", "LoggedIn");
            const data = await autologin();
            const firstProfile = (data && data.profiles && data.profiles.length > 0 && data.profiles[0]) || null;
            firstProfile && (await updateCurrentProfileInIndexDB({ ...firstProfile, isGenerateJWTToken: true }));
            const token = await sdk.authenticationManager.getToken();
            const cred = localStorage && localStorage.getItem("credentials");
            const status = "LoggedIn";
            const eventMsg = {
              message: `Pin Login `,
              level: "info",
              extra: {
                tok: token && formattedTokenForLogger(token),
                localCred: formattedTokenForLogger(cred),
                status: status,
                user: data
              }
            };
            captureEvent(eventMsg);
            trackEvent("session_start", PAGE, "session_start", data);
            getAppState().userAccountStatus = data?.settings?.accountStatus;
            getAppState().userAddonStatus = isAnyAddonStatusActive(data?.settings?.addons);
            if (voucherData) {
              const skipUserLangUpdate = true;
              stateActions.userLoggedIn(data, skipUserLangUpdate);
            } else stateActions.userLoggedIn(data);

            const { login, player, loginOrSignup, nonchangeable, home } = routes;
            if (voucherData && this.state.isVoucherRedeemed) {
              this.setState({ isVoucherRedeemed: false });
              const path = await checkForUmanagedOrNonChangeableMop.call(this);
              if (path === nonchangeable) {
                stateActions.setLocale(data.settings.language || data.locale);
                redirectTo.call(this, nonchangeable, historyMethods.REPLACE);
              } else if (!path) {
                this.redeemVoucher();
              }
            } else {
              redirectTo.call(this, routes.profileSelector, { nextPageReference: redirectPath }, navigationMode);
            }
          }
        } catch (error) {
          Sentry.captureException(error);
          console.log(error);
        }
      }, 5000);
    })(this);
    this.props.setFocus(loginFocusPath);
  }

  async redeemVoucher() {
    const { voucherData } = getAppState();
    const {
      history: { location },
      setFocus,
      stateActions
    } = this.props;
    try {
      this.setState({ isRedeeming: true });
      let baseCode = voucherData && voucherData.vouchers[0].code;
      let addonCode = undefined;
      this.setState({ isLoading: true });

      if (voucherData) {
        if (voucherData.status === "INVALID") {
          throw voucherData;
        }
        const vouchers = voucherData.vouchers.reduce((acc, val) => {
          if (val.subscriptions.includes("starzplay")) {
            acc.baseCode = val.code;
          } else {
            acc.addonCode = val.code;
          }
          return acc;
        }, {});

        baseCode = vouchers.baseCode;
        addonCode = vouchers.addonCode;
      }

      await eVoucherProvisioning(baseCode, addonCode);

      const userInfo = await getSdk().userManager.get({ avoidCache: true });
      stateActions.setLocale(userInfo.settings.language || userInfo.locale);
      trackEvent(SIGNUP, "evoucher_redemption_success", getRedemptionSuccessTrackingData.call(this));
      this.setState({ isRedeeming: false });
      getAppState().currentProfileType = userInfo?.profileType;
      localStorage.removeItem("voucherData");
      getAppState().userAccountStatus = userInfo.settings.accountStatus;
      getAppState().userAddonStatus = isAnyAddonStatusActive(userInfo?.settings?.addons);
      getAppState().addons = userInfo.settings.addons;
      getAppState().isActiveUser = userInfo.settings.accountStatus;
      getAppState().isSvodUser =
        isAnyAddonStatusActive(userInfo.settings?.addons) || isUserAccountActive(userInfo.settings.accountStatus)
          ? true
          : false;
      //getAppState().voucherData = null;

      redirectTo.call(
        this,
        routes.thankyou,
        location &&
          location.state &&
          location.state.fromSignup && {
            fromSignup: location.state.fromSignup
          },
        historyMethods.REPLACE
      );
    } catch (e) {
      const userInfo = await getSdk().userManager.get({ avoidCache: false });
      stateActions.setLocale(userInfo.settings.language || userInfo.locale);
      this.setState({ isLoading: false });
      this.setState({ isRedeeming: false });
      handleRequestError.call(this, e);
      setFocus(getGlobalButtonFocusPath("back"));
    } finally {
      this.setState({ isLoading: false });
    }
  }

  componentWillUnmount() {
    if (window.pinCheckTimer) {
      clearInterval(window.pinCheckTimer);
    }
  }

  enterHandler(eventAction, path, locationData) {
    // trackEvent(SIGNUP, eventAction);
    redirectTo.call(this, path, locationData, historyMethods.REPLACE);
  }

  onBack() {
    if (this.state.showQRModal) {
      this.props.setFocus(twistTvFocusPath);
      this.props.stateActions.hideGlobalModal();
      this.toggleQRCodeModal(false);
      return true;
    }
    const { applicationState, location, history } = this.props;
    if (applicationState && applicationState.voucherData) {
      const path = location.referrer ?? routes.promotions;
      redirectTo.call(this, path, null, historyMethods.REPLACE);
      return true;
    }
    const hasHistoryState = !!(location && location.state);
    if (this.state.backDestination || (hasHistoryState && location.state && location.state.backDestination)) {
      const backDestination = (location.state && location.state.backDestination) || this.state.backDestination;
      const backDestinationPathname = backDestination.pathname || backDestination;
      history.replace(backDestinationPathname, { from: { name: "/home" } });
      return true;
    }
    redirectTo.call(this, routes.home, null, historyMethods.REPLACE);
    return true;
  }

  closeModal(defaultFocusPath) {
    const {
      stateActions: { hideGlobalModal }
    } = this.props;
    hideGlobalModal();
  }
  closeTwistModal() {
    this.toggleQRCodeModal(false);
    this.props.setFocus(twistTvFocusPath);
    this.props.stateActions.hideGlobalModal();
  }

  render() {
    const { location } = this.props;
    const { locale } = this.state;
    return (
      <LandingPageStyled>
        {this.state.isLoading && <Loading overlay />}
        <PinLoginInfoContainer>
          <LeftBlock userLocale={locale}>
            <LandingContainerStyled>
              <TextStyled rank="1" text={i18n.get("pages.pinLogin.heading")} size="large" />
              <StepContainer userLocale={locale}>
                <StepNumber>1</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step1")} size="medium" />
                  <LinkStyled rank="2" userLocale={locale}>
                    {"starzplay.com/linktv"}
                  </LinkStyled>
                </StepTextContainer>
              </StepContainer>
              <StepContainer userLocale={locale}>
                <StepNumber>2</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step2")} size="medium" />
                </StepTextContainer>
              </StepContainer>
              <StepContainer userLocale={locale}>
                <StepNumber>3</StepNumber>
                <StepTextContainer>
                  <StepText rank="3" text={i18n.get("pages.pinLogin.step3")} size="medium" />
                  <PinContainerStyled userLocale={locale}>
                    {this.state.pin.split("").map((v, i) => (
                      <PinItemStyled key={`pin-${i}-${v}`}>{v}</PinItemStyled>
                    ))}
                  </PinContainerStyled>
                </StepTextContainer>
              </StepContainer>
            </LandingContainerStyled>
          </LeftBlock>
          <RightBlock userLocale={locale}>
            <AlignText>
              <LogoStyled>
                <FreeLogo />
              </LogoStyled>
            </AlignText>
            <QRCodeWrapper>
              <QRCodeReact value={`${getWebPortalURL()}/linktv?pin=${this.state.pin}`} size={432} />
            </QRCodeWrapper>
          </RightBlock>
        </PinLoginInfoContainer>
        <LoginOptionContainer style={{ display: "flex", flexDirection: "column" }}>
          <LineTextStyled>{i18n.get("pages.pinLogin.or")}</LineTextStyled>
          <ButtonsWrapper>
            <ButtonModalFocus
              label={i18n.get("pages.pinLogin.loginButton").toUpperCase()}
              focusPath={joinFocusPath}
              onEnterPress={() =>
                this.enterHandler("login_user_selects_passwordlogin", routes.login, location && location.state)
              }
              onMouseUp={() => this.enterHandler("login_user_selects_passwordlogin", routes.login)}
              size="medium"
              dataSnUp={""}
              dataSnDown={`@${loginFocusPath}`}
              dataSnLeft={i18n.getDirection() === "rtl" ? `@${twistTvFocusPath}` : ""}
              dataSnRight={i18n.getDirection() === "rtl" ? "" : `@${twistTvFocusPath}`}
              userLocale={locale}
            />
            {isTwistMigrationEnabled() && (
              <ButtonModalFocus
                label={i18n.get("pages.pinLogin.twistTV").toUpperCase()}
                focusPath={twistTvFocusPath}
                onEnterPress={() => {
                  trackEvent("mig_act_click", "", "mig_act_click");
                  this.toggleQRCodeModal(true);
                  QRModal.call(
                    this,
                    this.closeTwistModal.bind(this),
                    getTwistMigrationUrl(
                      `${getAppState().remoteConfig?.twist_to_sp_migration?.landing_page}?client_type=${
                        config.get().sdk.clientType
                      }`,
                      locale
                    ),
                    false
                  );
                }}
                size="medium"
                dataSnUp={""}
                dataSnDown={""}
                dataSnLeft={i18n.getDirection() === "rtl" ? "" : `@${joinFocusPath}`}
                dataSnRight={i18n.getDirection() === "rtl" ? `@${joinFocusPath}` : ""}
                userLocale={locale}
              />
            )}
          </ButtonsWrapper>
        </LoginOptionContainer>
      </LandingPageStyled>
    );
  }
}

export default withAppState(withSubtheme(PinLoginPage));
